export default __webpack_public_path__ + "static/02-03-teach-control-screen-3b9eed1b99b1572a8920dd5d2dd2017c.mp4";